module.exports = __webpack_public_path__ + "img/about_zhTc-.a7c66217.png";